module.exports = __webpack_public_path__ + "img/napkin.c112c96d.svg";